import { FormLabel, Typography } from "@mui/material";
import { usePermissions, useGetList } from 'react-admin';
import Paper from "@mui/material/Paper";
import LinearProgress from "@mui/material/LinearProgress";
import { templateSettings } from "lodash";
import ExcelReportButton from './ExcelReportButton'

import '../dashboard/printStyles.css';
import { useClientContext } from "contexts/client";

templateSettings.interpolate = /{{([\s\S]+?)}}/g;


const PresentationExcel = (props) => {
  const { permissions } = usePermissions()
  const { state } = useClientContext()

  const record = props.record;
  const clientPrefix = state.client.resourcePrefix;

  const { data, isPending } = useGetList(
      `${clientPrefix}_excel_reporting`,
      {
          pagination: { page: 1 , perPage: 100 },
          sort: { order: "desc", field: "id" },
          filter: {
              deploy_target: [props.deploy_target],
          }
      }
  );

  return (!isPending && data?.length !== 0) ? (
    <div
      className="hide-on-print"
      style={{
        padding: "1em",
      }}
    >
      {!isPending && data?.length !== 0 && (
        <Paper
          style={{
            padding: "1em",
            marginBottom: "1em",
          }}
        >
          <FormLabel sx={{'textDecoration': 'underline'}}>Excel Reports</FormLabel>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {data?.filter(r => (!r.is_draft))
              .map((r, idx) => (
                    <ExcelReportButton 
                        key={idx}
                        record={record}
                        filter_field={props.filter_field}
                        filter_by={props.filter_by}
                        name={r.name}
                        excel_configuration={r.excel_configuration}
                        is_draft={r.is_draft}
                    />
                )
            )}
          </div>
          
          {(data?.filter(r => (permissions === 'site_admin' && r.is_draft)).length > 0)
              && <FormLabel sx={{'textDecoration': 'underline'}}>Draft Reports</FormLabel>
          }
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {data?.filter(r => (permissions === 'site_admin' && r.is_draft))
              .map((r, idx) => (
                    <ExcelReportButton
                        key={idx}
                        record={record}
                        filter_field={props.filter_field}
                        filter_by={props.filter_by}
                        name={r.name}
                        excel_configuration={r.excel_configuration}
                        is_draft={r.is_draft}
                    />
                )
            )}
          </div>
        </Paper>
      )}

      {!isPending && data?.length === 0 ? (
        <Typography
          variant="h5"
          color="textSecondary"
          style={{
            textAlign: "center",
            paddingTop: "3em",
            paddingBottom: "3em",
          }}
        >
          No Reports are configured for this target.
        </Typography>
      ) : null}
      {(isPending) ? (
        <LinearProgress variant="query" />
      ) : null}
    </div>
  ) : null;
};

export default PresentationExcel;
